import React, {createContext, useContext, useState} from 'react';

const ApolloLoaderContext = createContext({
  apolloLoading: true,
});

const ApolloLoaderContextProvider = ({children}) => {
  const [apolloLoading, setApolloLoading] = useState(true);
  return (
    <ApolloLoaderContext.Provider value={{apolloLoading, setApolloLoading}}>
      {children}
    </ApolloLoaderContext.Provider>
  );
};

const useApolloLoaderContext = () => useContext(ApolloLoaderContext);

export {ApolloLoaderContextProvider, useApolloLoaderContext};
